import PropTypes from 'prop-types';
import React from 'react';
import Highlighter from 'react-highlight-words';
import { formatMetricName } from '../../teamManagement/utils';
import Checkbox from '../atoms/Checkbox';
import Tooltip from '../molecules/Tooltip';
import css from './LabeledCheckboxList.css';

const LabeledCheckboxList = ({ fields = [], columnsNumber = 4, onChange = () => {}, search = '' }) => {
    const style = {
        textOverflow: 'ellipsis',
        width: `${100 / columnsNumber}%`,
        overflow: 'hidden',
        paddingRight: '5px',
        fontSize: '14px',
        whiteSpace: 'nowrap',
    };
    const checkmarkStyle = {
        marginRight: '6px',
    };

    return (
        <div className={css.lisContainer}>
            {fields.map(field => {
                const label = formatMetricName(field);
                return (
                    <Checkbox
                        key={field.id}
                        style={style}
                        checkmarkStyle={checkmarkStyle}
                        checked={field.selected}
                        label={
                            <Tooltip title={label}>
                                <Highlighter searchWords={[search]} textToHighlight={label} autoEscape />
                            </Tooltip>
                        }
                        labelTooltip={field.tooltip}
                        onChange={() => onChange(field.name, !field.selected)}
                        size="small"
                    />
                );
            })}
        </div>
    );
};

LabeledCheckboxList.propTypes = {
    fields: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            display_name: PropTypes.string.isRequired,
            selected: PropTypes.bool.isRequired,
            name: PropTypes.string.isRequired,
            tag: PropTypes.string,
            tooltip: PropTypes.string,
        })
    ),
    columnsNumber: PropTypes.number,
    onChange: PropTypes.func,
    search: PropTypes.string,
};

export default LabeledCheckboxList;
